import { Component, OnInit, EventEmitter } from '@angular/core';
import { DialogComponent, DialogService } from "ng2-bootstrap-modal";
import { UserService } from '../../../_services/user.service';

@Component({
    selector: 'app-adduser',
    templateUrl: './adduser.component.html',
    styleUrls: ['./adduser.component.css']
})
export class AddUserComponent extends DialogComponent<null, boolean> implements OnInit {

    model: any = {};
    loading = false;
    message: string;
    returnUrl: string;
    focusEventEmitter = new EventEmitter<boolean>();
    
    constructor(dialogService: DialogService, private userService: UserService) {
        super(dialogService);
    }

    ngOnInit() {

    }

    ngAfterViewInit() {
        this.focusEventEmitter.emit(true);
    }
    
    add() {
        this.message = '';
        this.loading = true;
        this.userService.add(this.model).subscribe(
            data => {
                if (data.exists) {
                    this.message = data.message;
                }
                else {
                    this.close();
                    this.result = true;
                }
            },
            error => {
                this.message = error.json().message; 
                this.loading = false;
            }, () => {
                this.loading = false;
            }
        );
    }

}



// WEBPACK FOOTER //
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/_components/user/adduser/adduser.component.ts